/**
 * Free Share of Search tier caps (M0 draft values — revisit after the
 * data-requirements review; APP-441). Keyword counts do not affect Google
 * API cost (only regions do), these bound report size and edit churn.
 */
export const SOS_FREE_MAX_CATEGORIES = 5
export const SOS_FREE_MAX_COMPETITORS = 5

// Preston's Calendly (set 2026-08-19). Single source for every booking CTA;
// APP-454 may still replace the link-out with an embedded scheduler.
export const SOS_BOOK_A_CALL_URL = "https://calendly.com/prestonr2/30min"

// Upsell copy shared by the /upgrade page and the report-page modal.
// Placeholder wording — final copy comes with APP-489.
export const SOS_UPSELL_HEADLINE =
  "Your share of search is a symptom. Let's diagnose the cause."
export const SOS_UPSELL_BODY =
  "Share of search shows where your brand stands. In 30 minutes, our founders show you what's driving it — media, creative, or brand — and what we'd do about it."

// Report-ready popup copy (APP-487). Placeholder wording — final copy comes
// with APP-489.
export const SOS_REPORT_READY_HEADLINE =
  "Your report is ready — let's review it together."
export const SOS_REPORT_READY_BODY =
  "Your first Share of Search report just landed. Book 30 minutes with a founder and we'll walk through it with you."
